import { render, staticRenderFns } from "./MyPartnerFigures.vue?vue&type=template&id=2c89c588"
import script from "./MyPartnerFigures.vue?vue&type=script&lang=js"
export * from "./MyPartnerFigures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports